<template>    
  <div class="content test">
 
    <b-container fluid >
      <div>
        <card class="no-border-card" body-classes=" p-4" footer-classes="pb-2">

          <b-row class="justify-content-md-center" align-v="center" >
            <b-col>
              <h1 class="mb-0">Lists</h1>
            </b-col>
            <b-col class="float-right">
              <base-button icon type="success" class="float-right"  @click="toggle_new_list_modal" >
                <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18 color_white">add</span></span>
                <span class="btn-inner--text">Create List</span>
              </base-button>
            </b-col>
          </b-row>
        </card>

        <!-- list table -->
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2" v-if="$parent.contact_lists.length > 0">
         
          <div>

            <ve-table :columns="columns" :table-data="tableData" :sort-option="sortOption" :fixed-header="true" ref="lists_table" ></ve-table>
             <div class="table-pagination mt-3">
                <ve-pagination
                    :total="totalCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>

          </div>
          
        </card>
        <!-- list table -->

      </div>

      <!-- new list modal -->
      <div>
      
        <modal :show.sync="modals.new_list.show_modal" class="modal-xl" body-classes="p-0" id="new_list_modal" ref="new_list_modal"
         
        >


          <card 
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <h2>Create New List</h2>
              </div>

              <div v-if="modals.new_list.errors.length > 0">
                <b-alert show variant="danger" v-for="new_list_errors in modals.new_list.errors" v-bind:key="new_list_errors"
                                :error_text="new_list_errors" >
                  <strong>{{new_list_errors}}</strong>
                </b-alert>
              </div>

              <b-form role="form">
                <base-input alternative
                            v-model="modals.new_list.form_data.list_name"
                            class="mb-3"
                            placeholder="List Name"
                            prepend-icon="drive_file_rename_outline">
                </base-input>
                
                <b-form-group label="Active" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                  <base-switch class="mr-1" v-model="modals.new_list.form_data.is_active"></base-switch>
                </b-form-group>

              
              </b-form>

              

          </card>

          
      

         <template slot="footer">
          <base-button type="danger" @click="close_new_list_modal()">Cancel</base-button>
          <base-button type="success" @click="submit_new_list()" :disabled="modals.new_list.is_busy" ref="create_list_button">Create List <span v-if="modals.new_list.is_busy" class="material-icons material-icons-outlined">hourglass_empty</span> </base-button>
          

        </template>
        </modal>


      </div>


    </b-container>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import swal from 'sweetalert2';
import { BModal } from 'bootstrap-vue'
import VueEasytable  from "vue-easytable";
import moment from 'moment';


export default {
  mixins: [],
  components: {
    BModal,
    VueEasytable
  },
  data() {
    return {
      is_inside_change_data_callback: false,
      changed_row_index_numbers: [],



      pageIndex: 1,
      pageSize:10,

      columns: [
        {
            field: "list_name",
            key: "list_uuid",
            title: "Name",
            width:120,
            align: "left",
            renderBodyCell: ({ row, column, index }, h) => {
              if(!row.date_created) {
                return <div>{row.list_name}</div>
              } else {
                return (
                  <div v-b-tooltip={moment(row.date_created).format('MM/DD/YYYY')}>{row.list_name}</div>
                )
              }
            }
        },
        {
            field: "date_created",
            key: "date_created",
            title: "Date",
            width: 90,
            align: "left",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              if(!row.date_created) {
                return
              } else {
                return moment(row.date_created).format('MM/DD/YYYY');
              }
            }
        },
        {
            field: "is_active",
            key: "is_active",
            title: "Active",
            align: "left",
            width: 80,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              let real_row_index
              if(this.pageIndex === 1) {
                real_row_index = ++rowIndex
              } else {
                rowIndex = rowIndex +1
                real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
              }
      
              return (
              
                <div slot-scope="{real_row_index, row}" class="d-flex" >
                  <base-switch class="mr-1" v-model={this.$parent.contact_lists[real_row_index-1].is_active}  onTrigger_function={() => this.change_this_list((real_row_index-1),this.$parent.contact_lists[real_row_index-1])}  ></base-switch> 
                </div>
                
              )
              
            }
        },
        {
          field: "contacts",
          key: "contacts",
          title: "Contacts",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {

            try {
              //this.contact_lists_stats arary of rows list_uuid, count_all, is_twilio_verified_cell is_sms_optin etc
              let found_match_this_stats_uuid
              if(typeof this.$parent.contact_lists_stats !== 'undefined' && this.$parent.contact_lists_stats.length && this.$parent.contact_lists_stats.length > 0) {
                this.$parent.contact_lists_stats.forEach(single_stat_to_search => {
                  if(single_stat_to_search.list_uuid && single_stat_to_search.list_uuid === row.list_uuid) {
                    found_match_this_stats_uuid = single_stat_to_search
                  }
                });
              }
              if(typeof found_match_this_stats_uuid !== 'undefined' && found_match_this_stats_uuid !== null) {
                
                return (
                  <b-container class="bv-example-row">
                  
                    <b-progress class="" max={found_match_this_stats_uuid.count_all} show-value>

                      <b-progress-bar value={found_match_this_stats_uuid.twilio_verified_cell} variant="success">
                        
                      </b-progress-bar>

                      <b-progress-bar value={found_match_this_stats_uuid.is_sms_optout} variant="danger" ></b-progress-bar>
                    </b-progress>
                 
                  </b-container>
                )

              } else {
                return
              }
            } catch(e) {
              console.log(e)
              return
            }
            
          }
        },
        {
          field: "download",
          key: "download",
          title: "",
          width:30,
          align: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if(this.$parent.active_user && this.$parent.active_user.permissions && !this.$parent.active_user.permissions.includes('contacts:read_bulk')  ) {
              if(this.$parent.active_user.admin !== true) {
                return
              }
            } 
            return (
              <base-button
                onClick={() =>
                  this.download_this_list(null, row)
                }
              
                class="btn-link"
                type="success"
                size="sm"
                icon
              >
                <span class="material-icons material-icons-outlined color-white">cloud_download</span>
              </base-button>
            )
          }
        }

        


      ],
      sortOption: {
          multipleSort: true,
          sortChange: (params) => {
              console.log("sortChange::", params);
              this.sortChange(params);
          },
      },
      

      modals: {
        
        new_list: {
          show_modal: false,
          is_busy: false,
          errors: [

          ],
          default_form_data: {

            "org_id":this.$parent.active_org.org_id,
            "front_team_id":this.$parent.active_org.front_team_id,
            "list_type":"SMS",
            "is_active":true,
            "user_uuid_created":this.$parent.active_user.user_uuid,
            //"list_uuid":null,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "list_name":null
            //"date_created":"2021-08-17T23:58:52.724000000Z",
            //"last_modified":"2021-08-17T23:58:52.724000000Z",
            
            
          },
          form_data: {//pre-populate on the fist modal overlay hack
            "org_id":this.$parent.active_org.org_id,
            "front_team_id":this.$parent.active_org.front_team_id,
            "list_type":"SMS",
            "is_active":true,
            "user_uuid_created":this.$parent.active_user.user_uuid,
            //"list_uuid":null,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "list_name":null
          }
        }
      }
    };
  },
  computed: {
    totalCount() {
        return this.$parent.contact_lists.length || 0
    },
    tableData() {
        const { pageIndex, pageSize } = this;
        return this.$parent.contact_lists.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    }
  },
  created() {
    window.addEventListener("resize", this.window_resize_function);
    this.window_resize_function()
  },
  destroyed() {
    window.removeEventListener("resize", this.window_resize_function);
  },
  methods: {
    calculate_window_width() {
      var this_width = 0
      if( typeof( window.innerWidth ) == 'number' ) {
        //Non-IE
        this_width = window.innerWidth;
      } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
        //IE 6+ in 'standards compliant mode'
        this_width = document.documentElement.clientWidth;
      } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
        //IE 4 compatible
        this_width = document.body.clientWidth;
      }
      return this_width
    },
    //mobile hide date i think
    window_resize_function(event) {
      //if(event.type && event.type === 'resize') {
        let this_width =  this.calculate_window_width() 

        if(this_width <= 600) {
          this.hideColumns(['date_created'],'lists_table')
        } else {
          this.showColumns(['date_created'],'lists_table')
        } 
      //}
    },
    hideColumns(keys,table_ref) {
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }

      //make sure element exists
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].hideColumnsByKeys(keys);
        }
      })
      
    },
    // show cloumns
    showColumns(keys,table_ref) {   //array, ref
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].showColumnsByKeys(keys)
        }
        
      })
    },
    pageNumberChange(pageIndex) {
        this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
        this.pageIndex = 1;
        this.pageSize = pageSize;
    },

    sortChange(params) {

      console.log('debug sortChange ')
      console.log(params)
      let data = this.tableData.slice(0);

      data.sort((a, b) => {
          if (params.list_name) {
              if (params.list_name === "asc") {
                  return a.list_name - b.list_name;
              } else if (params.list_name === "desc") {
                  return b.list_name - a.list_name;
              } else {
                  return 0;
              }
          } else  if (params.org_id) {
              if (params.org_id === "asc") {
                  return a.org_id - b.org_id;
              } else if (params.org_id === "desc") {
                  return b.org_id - a.org_id;
              } else {
                  return 0;
              }
          }
      });

      this.tableData = data;
    },
    change_this_list: function(index,row) {
      console.log('305 tick one ')
      console.log(JSON.stringify(row) || null)

      console.log('console.log(this.$parent.contact_lists[index].is_active)')
        console.log(this.$parent.contact_lists[index].is_active)
        console.log('console.log(row.is_active)')
        console.log(row.is_active)



      this.$nextTick(() => {
        //so dont do two at once
         console.log('309 tick 2 ')
        console.log(JSON.stringify(row) || null)

        console.log('console.log(this.$parent.contact_lists[index].is_active)')
          console.log(this.$parent.contact_lists[index].is_active)
          console.log('console.log(row.is_active)')
          console.log(row.is_active)

        if(!this.changed_row_index_numbers.includes(index)) {
          this.changed_row_index_numbers.push(index)
          this.post_new_row_data(index,row,0)
        } else {
          return swal.fire({
              title: `Warning`,
              text: 'Error previous request still loading refresh and try again',
              buttonsStyling: false,
              icon: 'warning'
            })
        }
      })

    },
    removeItemAll: function(arr, value) {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    },
    post_new_row_data: function(index,row,attempts) {
      //let this_row_elements = document.getElementsByClassName("el-table__row")
      //this_row_elements[index].classList.add("table_row_loading");

      try {
        row.user_uuid_last_modified = this.$parent.active_user.user_uuid
        if(this.$parent.active_user && this.$parent.active_user.permissions && !this.$parent.active_user.permissions.includes('contacts:create')) {
          if(this.$parent.active_user.admin !== true) {
            return swal.fire({
              title: `Warning`,
              text: 'you do not have permissions to update. contact admin',
              buttonsStyling: false,
              icon: 'warning'
            })
          } 
        }
        if(attempts && attempts > 1) {
            console.log('426 attempts ' + attempts)
            console.log('state didnt align did not post this data?')
            console.log(index)
            console.log(JSON.stringify(row))
            console.log(JSON.stringify(this.$parent.contact_lists[index]))
            this.removeItemAll(this.changed_row_index_numbers,index)
            return swal.fire({
              title: `Warning`,
              text: 'Stat error. This did not save. Refresh to try again and contact admin.',
              buttonsStyling: false,
              icon: 'warning'
            })
        }

        console.log('366 tick 3')

        this.$nextTick(() => {
          console.log('console.log(this.$parent.contact_lists[index].is_active)')
          console.log(this.$parent.contact_lists[index].is_active)
          console.log('console.log(row.is_active)')
          console.log(row.is_active)

          console.log('tick 4 374')

          if(JSON.stringify(row) !== JSON.stringify(this.$parent.contact_lists[index]) ) {
            console.log('debug 429 state does not match? timeout?')
            console.log(JSON.stringify(row))
            console.log(JSON.stringify(this.$parent.contact_lists[index]))

            setTimeout(() => {
              return this.post_new_row_data(index,row,(attempts+1))
            }, 1000);
          } else {
            
              axios.post('https://'+this.$parent.use_this_api_domain+'/contact/list', row, {
                headers: {
                  'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                }
              })
              .then((result,error) => {
                if(result) {
                  console.log('should match')
                  console.log(JSON.stringify(this.$parent.contact_lists[index]))
                  console.log(JSON.stringify(result.data))

                  this.$parent.contact_lists[index] = result.data
                  //set_this_active_list,set_this_active_script,recursive_loop_count,recursive_time,set_this_active_campaign_uuid
                  this.$parent.cascade_updates_on_new_active_campaign(result.data.list_uuid,null,0,1000,null)

                }
                if(error) {
                  console.log('debug update campaign error ')
                  console.log(JSON.stringify(error))
                }

                this.removeItemAll(this.changed_row_index_numbers,index)

              })
              
          }
        })


      } catch(e) {
        console.log(e)
       // console.log('finally')
       // this.changed_row_index_numbers = []
       // this.is_inside_change_data_callback = false
        removeItemAll(this.changed_row_index_numbers,index)
      }
    },
    toggle_new_list_modal: function() {
      this.modals.new_list.show_modal = true
      //this.$refs['new_list_modal'].toggle('#toggle_new_list_modal')
    },
    close_new_list_modal: function() {
      //reset the data
      this.modals.new_list.form_data = this.modals.new_list.default_form_data 

      //clear any erors 
      this.modals.new_list.errors = []
      //close
      this.modals.new_list.show_modal = false
      this.modals.new_list.is_busy = false

    },
    submit_new_list: function(this_event) {
      
      console.log('submiting this list: ')
      console.log(this.modals.new_list.form_data)
      

      //make sure has a few details
      if(!this.modals.new_list.form_data.list_name) {
        this.modals.new_list.errors.push("Must have a list name")
      } else  {
        this.modals.new_list.errors = this.modals.new_list.errors.filter(e => e !== "Must have a list name")
      }

      if(this.modals.new_list.form_data.list_name && this.modals.new_list.form_data.list_name.length < 7) {
        this.modals.new_list.errors.push("Please write a longer list name, at least 8 characters")
      } else {
        this.modals.new_list.errors = this.modals.new_list.errors.filter(e => e !== "Please write a longer list name, at least 8 characters")
      }

      //always sms simplify
      if(!this.modals.new_list.form_data.list_type) {
        this.modals.new_list.form_data.list_type = 'SMS'
      }
      /*
      if(!this.modals.new_list.form_data.list_type) {
        this.modals.new_list.errors.push("Must have a list type")
      } else {
        this.modals.new_list.errors = this.modals.new_list.errors.filter(e => e !== "Must have a list type")
      }*/

      if(this.modals.new_list.form_data.is_active === null) {
        this.modals.new_list.errors.push("Must select active or not")
      } else {
        this.modals.new_list.errors = this.modals.new_list.errors.filter(e => e !== "Must select active or not")
      }
      

      if(this.modals.new_list.errors.length > 0) {
        //do nothing
        this.modals.new_list.is_busy = false
      } else {

        //add the default data from the base
        //TODO maybe it makes more sense to use a computed but im tired
        this.modals.new_list.form_data.org_id =  this.modals.new_list.default_form_data.org_id
        this.modals.new_list.form_data.front_team_id =  this.modals.new_list.default_form_data.front_team_id
        this.modals.new_list.form_data.user_uuid_last_modified =  this.modals.new_list.default_form_data.user_uuid_last_modified
        this.modals.new_list.form_data.user_uuid_created =  this.modals.new_list.default_form_data.user_uuid_created

        //show modal as loading
        this.modals.new_list.is_busy = true

        //post the data
        
        axios.post('https://'+this.$parent.use_this_api_domain+'/contact/list',  
          this.modals.new_list.form_data, {
                headers: {
                  'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                }
              })
        .then(response => {
          console.log(response)
          if(response.status === 200) {
            //add the returned data (so it has timestamps etc) into the table
            console.log('new list created')
            console.log(response.data)
            this.$parent.contact_lists.unshift(response.data)
            this.$parent.cascade_updates_on_new_active_campaign(null,response.data.list_uuid || null)
            //instead of push add to the start... i dont think i need to add though because it's added above
            //this.tableData.unshift(response.data)

          } else {
             swal.fire({
              title: `Warning`,
              text: 'Error creating new list',
              buttonsStyling: false,
              icon: 'warning'
            })
            
            console.log(response.data)
          }

        })
        .catch(error =>  {
          swal.fire({
            title: `Warning`,
            text: 'Error creating new list',
            buttonsStyling: false,
            icon: 'warning'
          })
          console.log(error.response.data)
        })
        .finally(has_something => {
          console.log('is done posting new list data')
          //close the modal
          //reset the data
          this.modals.new_list.form_data = this.modals.new_list.default_form_data 

          //clear any erors 
          this.modals.new_list.errors = []
          //close
          this.modals.new_list.show_modal = false
          this.modals.new_list.is_busy = false


        })
      }

    },
    download_this_list: function(index,row) {
      //get the list_uuid
      //get url like https://fullstackapp-dot-smiling-garden-126003.appspot.com/contact/list/download?org_id=d0ed245477da095ad3147488ba2b238b&front_team_id=tim_2r841&user_uuid=bb77d9ac-7c4e-4255-a566-dcda2c1b07f1&list_uuid=9bbd3e99-caf3-46a4-9571-a61673ed34bc
      try {

        if(this.$parent.active_user && this.$parent.active_user.permissions && !this.$parent.active_user.permissions.includes('contacts:read_bulk')  ) {
          if(this.$parent.active_user && this.$parent.active_user.admin !== true) {
            return swal.fire({
              title: `Warning`,
              text: 'No permission to download',
              buttonsStyling: false,
              icon: 'warning'
            })
          }
        } 

        function fire_swal_error() {
          return swal.fire({
            title: `Error generating csv file to download. Contact admin.`,
            buttonsStyling: false,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill'
          });
        }
        let this_download_url = 'https://'+this.$parent.use_this_api_domain+'/contact/list/download?'

        if(row.org_id !== null) {
          this_download_url = this_download_url+'org_id='+row.org_id
        } else {
          console.log('missing org_id ?')
          return fire_swal_error()
        }

        if(this.$parent.active_user.user_uuid!== null) {
          this_download_url = this_download_url+'&user_uuid='+this.$parent.active_user.user_uuid
        } else {
          console.log('missing user_uuid ?')
          return fire_swal_error()
        }

        if(row.list_uuid !== null) {
          this_download_url = this_download_url+'&list_uuid='+row.list_uuid
        } else {
          console.log('missing list_uuid ?')
          return fire_swal_error()
        }

        //try axios for auth header pass
        //window.location.assign(this_download_url);

        //220513 what about generate a url with a ?jwt param?
        this_download_url = this_download_url+'&jwt='+ this.$parent.active_user_jwt
        
        const link = document.createElement('a');
        link.href = this_download_url;
        link.target = '_blank'
        document.body.appendChild(link);
        link.click();

        /*
        axios.get(this_download_url, {
          headers: {
            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
          }
        })
        .then(response => {

          //const url = window.URL.createObjectURL(response.data)
          //const link = document.createElement('a');
          //link.href = url;
          //link.setAttribute('download', 'file.pdf');
          //document.body.appendChild(link);
          //link.click();

          let blob = new Blob([response.data], { type: 'text/csv' }),
          url = window.URL.createObjectURL(blob)

          window.open(url) // Mostly the same, I was just experimenting with different approaches, tried link.click, iframe and other solutions
        })
        */
      } catch(e) {
        console.log(e)
      }
    }
  }
};


</script>
<style>
.progress {
  height: 30px;
  margin-bottom: auto;
}
.progress .bg-danger {
  min-width:15px
}
  .no-border-card .card-footer{
    border-top: 0;
  }
  .table_row_loading {
    opacity: .5;

  }
  div.el-table  .table_row_loading {
    background-color: var(--gray) !important;
  }
  .card .table td, .card .table th, .card .el-table td, .card .el-table th {
    padding-left: 5px;
    padding-right:5px;
  }
</style>
